const isPreviewOrProduction = import.meta.env.MODE !== "development";
const isActualProduction = import.meta.env.MODE === "production";
const isDevelopment = import.meta.env.MODE === "development";

export const env = {
  CLERK_PUBLIC_KEY: isDevelopment
    ? "pk_test_cGF0aWVudC1jcmF3ZGFkLTAuY2xlcmsuYWNjb3VudHMuZGV2JA"
    : "pk_live_Y2xlcmsudGVhbXotdGVubmlzLmNvbSQ",

  isPreviewOrProduction,
  isActualProduction,
  isDevelopment,

  // En dev, VITE_TEAMZ_API_URL permet de pointer une API sur un autre port
  // quand 3000 est déjà pris par un autre projet local.
  API_URL: isDevelopment
    ? import.meta.env.VITE_TEAMZ_API_URL ?? "http://localhost:3000"
    : import.meta.env.VITE_TEAMZ_API_URL ?? "https://api.teamz-tennis.com",

  STREAMCHAT_API_KEY: isDevelopment ? "g9sajaa89a5s" : "a73d4pg8vckv",
};
